import clsx from 'clsx';
import isEmpty from 'lodash/isEmpty';
import React, { Fragment } from 'react';

import { IMGIX_URL } from '../../src/env';
import DetailsRow from './DetailsRow';
import styles from './styles.module.scss';

const enterpriseImgixUrl = `${IMGIX_URL}/global/projects/enterprise-power-list/edited`;
const SCREEN_MD = 992;
const MAX_TEXT_LENGTH = 110; // max characters for shortened description text

const getPersonPhotoUrl = (person) =>
  `${enterpriseImgixUrl}/${person.photo}?fmt=webp&w=250&h=250&fit=crop`;

const PowerlistRow = ({ details, handleClose, handlePersonClick, row, rowNum }) => {
  const shortenText = (longText) => {
    let shortenedText = longText.substr(0, MAX_TEXT_LENGTH);
    return shortenedText
      .substr(0, Math.min(shortenedText.length, shortenedText.lastIndexOf(' ')))
      .concat('...');
  };

  return (
    <div className="Row">
      <div className="profile-row">
        {row.map((person) => (
          <Fragment key={person.rank}>
            <div className="person-container mb3" onClick={() => handlePersonClick(person, rowNum)}>
              <div className={`enterprise-rank${person.rank >= 10 ? ' --extend' : ''}`}>
                {person.rank}
              </div>
              <div
                className={clsx(styles.imageContainer, 'portrait-image-container')}
                style={{
                  WebkitMaskImage: `url(${getPersonPhotoUrl(person)})`,
                  WebkitMaskSize: '250px auto',
                }}
              >
                <img height={250} width={250} src={getPersonPhotoUrl(person)} />
                <div className="hidden-text">Read More</div>
              </div>
              <div className={styles.personName}>{person.name}</div>
              <div className={clsx(styles.personFirm, 'mt1')}>{person.firm}</div>
              <div className={styles.shortDescription}>{shortenText(person.description)}</div>
            </div>
            {details?.name === person.name && window.innerWidth <= SCREEN_MD && (
              <DetailsRow details={details} handleClose={handleClose} />
            )}
          </Fragment>
        ))}
      </div>
      {!isEmpty(details) && details.rowNum === rowNum && window.innerWidth > SCREEN_MD && (
        <DetailsRow details={details} handleClose={handleClose} />
      )}
    </div>
  );
};

export default PowerlistRow;
